import _ from 'lodash';

import {PERMISSION_LIST} from '@/utils/permissions';
import {LICENCE_ABILITIES} from '@/utils/licences';
import { dateToRu, dateToLocal, timezone } from '@/utils/date';

//TODO ВАЖНО! Разнести все методы в миксинах по одному на файл
export default {
  methods: {
    generateSortParams(prop, order) {
      switch (order) {
      case 'ascending':
        return `${prop}`
      case 'descending':
        return `-${prop}`
      default:
        return null;
      }
    },

    dateRuFormat(iso) {
      return dateToRu(iso) || 'Неизвестно';
    },

    imageMetaToTableData(data) {
      const meta = JSON.parse(data);
      const result = [];

      for (const key in meta) {
        result.push({
          key: key,
          value: meta[key]
        });
      }

      return result;
    },

    eventNameSplitter(eventName) {
      return eventName.split('.')[1];
    },

    userFormatter(val) {
      if (!val) {
        return 'Неизвестно';
      } else return val.name;
    },
    getNested(object, path, defaultValue = 'Неизвестно') {
      return _.get(object, path, defaultValue);
    },
    eventFormatter(event) {
      switch (event) {
      case 'opened':
        return {
          type: 'info',
          text: 'Переход на страницу'
        }
      case'created':
        return {
          type: 'success',
          text: 'Создание'
        };
      case'deleted':
        return {
          type: 'danger',
          text: 'Удаление'
        };
      case'updated':
        return {
          type: null,
          text: 'Обновление'
        };
      default:
        return {
          type: null,
          text: '-'
        };
      }
    },
    clearFilter(items = []) {
      items.forEach(filter => {
        Object.keys(filter).forEach(value => {
          filter[value].value = '';
        });
      });
    }
  },
  computed: {
    timeZone() {
      return timezone()
    },
    permissionList() {
      return PERMISSION_LIST;
    },
    licenceAbilitiesList() {
      return LICENCE_ABILITIES;
    }
  },
  filters: {
    dateFormat(date, timezone = 'utc', format = 'dd.MM.y HH:mm:ss') {
      if (!date) {
        return 'Неизвестно';
      }
      return dateToLocal(date, timezone, format)
    }
  }
};
